import localee1b4a28a from '../../lang/paywall.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"paywall","numberFormats":{"paywall":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"mbooks":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"24orepro":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"paywall","file":"paywall.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"mbooks","file":"mbooks.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"rinnovi","file":"paywall.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"24orepro","file":"solepro.js","iso":"it_IT","defaultCurrency":"EUR"}],
  defaultLocale: "paywall",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/var/www/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: true,
  baseUrl: "https://abbonamenti.ilsole24ore.com",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "IT",
  normalizedLocales: [{"code":"paywall","file":"paywall.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"mbooks","file":"mbooks.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"rinnovi","file":"paywall.js","iso":"it_IT","defaultCurrency":"EUR"},{"code":"24orepro","file":"solepro.js","iso":"it_IT","defaultCurrency":"EUR"}],
  localeCodes: ["paywall","mbooks","rinnovi","24orepro"],
}

export const localeMessages = {
  'paywall.js': () => Promise.resolve(localee1b4a28a),
  'mbooks.js': () => import('../../lang/mbooks.js' /* webpackChunkName: "lang-mbooks.js" */),
  'solepro.js': () => import('../../lang/solepro.js' /* webpackChunkName: "lang-solepro.js" */),
}
